<template>
  <div>
    <nav
      v-show="!is_open_sidebar"
      :class="[
        'navbar fixed-top',
        isScrolled ? 'navbar-primary shadow-sm' : 'bg-transparent',
      ]"
    >
      <div class="container">
        <router-link to="/efunding">
          <img
            alt="efunding-logo"
            :src="
              isScrolled
                ? require('@/assets/images/landing_page/img-logo-efunding-white.png')
                : require('@/assets/images/landing_page/img-logo-efunding.png')
            "
            class="logo-img"
          />
        </router-link>

        <div id="navbar-menu" class="d-none d-lg-flex gap-5">
          <div
            v-for="menu in navbarMenu"
            :key="menu.id"
            class="position-relative"
            ref="produkDropdown"
          >
            <!-- Jika menu adalah 'Produk Kami' -->
            <template v-if="menu.label === 'Produk Mitra Kami'">
              <div class="produk-dropdown-container">
                <a
                  href="#"
                  :class="[
                    'mr-3 produk-button',
                    isProdukActive ? 'menu-item-active' : 'navbar-menu-item'
                  ]"
                  @click.prevent="toggleProdukDropdown"
                >
                  {{ menu.label }}
                </a>

                <div
                  v-show="isProdukDropdownOpen"
                  class="dropdown-produk absolute mt-2 py-2 w-48 bg-blue-800 rounded-md shadow-xl"
                >
                  <a
                    href="/layanan-kami"
                    class="block px-4 py-2 text-sm text-white"
                  >
                    Semua Layanan
                  </a>
                  <a
                    href="/list-produk-deposito"
                    class="block px-4 py-2 text-sm text-white"
                  >
                    Deposito
                  </a>
                  <a
                    href="/list-produk-tabungan"
                    class="block px-4 py-2 text-sm text-white"
                  >
                    Tabungan
                  </a>
                  <!-- <a
                    href="/list-produk-lending"
                    class="block px-4 py-2 text-sm text-white"
                  >
                    Pembiayaan
                  </a> -->
                </div>
              </div>
            </template>

            <!-- Menu biasa -->
            <template v-else>
              <a
                :href="menu.pathname"
                :class="[
                  'mr-3',
                  currentPath === menu.pathname
                    ? 'menu-item-active'
                    : 'navbar-menu-item',
                ]"
              >
                {{ menu.label }}
              </a>
            </template>
          </div>
        </div>
        <!-- Bagian auth button -->
        <div id="auth-button" class="d-none d-lg-flex align-items-center">
          <!-- Jika belum login -->
          <template v-if="!userLoggedin">
            <button class="button-secondary mr-3" @click="$router.push('/login')">Masuk</button>
            <button class="button-primary" @click="registerFormOpen">Daftar</button>
          </template>

          <template v-else>
            <!-- <button
              v-if="currentUser.info.role_id == 5"
              class="button-futuristic mr-4"
              @click="redirectToNewDashboard"
            >
              Coba Dashboard Baru ✨
            </button> -->
            <div class="user-dropdown-container position-relative">
              <button class="button-secondary" @click="toggleUserDropdown">
                <i class="fas fa-user-circle mr-2"></i> {{ name }}
              </button>

              <div
                v-show="isUserDropdownOpen"
                class="dropdown-user absolute right-0 mt-2 py-2 w-48 rounded-md shadow-xl"
              >
                <a
                  v-if="currentUser.info.role_id == 5"
                  href="/dashboard"
                  class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  Dashboard
                </a>
                <a
                  v-if="currentUser.info.role_id == 6"
                  href="/agency/dashboard"
                  class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  Dashboard
                </a>
                <a
                  v-if="currentUser.info.role_id == 3 || currentUser.info.role_id == 4"
                  href="/pengajuan-saya?q=Profil"
                  class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  Profil
                </a>
                <a
                  href="#"
                  @click="handleLogout"
                  class="block px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                >
                  Sign Out
                </a>
              </div>
            </div>
          </template>
        </div>

        <!-- Toggle sidebar for mobile -->
        <button class="icon-button d-flex d-lg-none" @click="sidebarToggle">
          <Bars3Icon style="width: 2rem; height: 2rem; color: #fff" />
        </button>
      </div>
    </nav>
    <!-- Sidebar -->
    <transition name="sidebar">
      <aside v-if="is_open_sidebar" class="sidebar">
        <div class="aside-header">
          <img
            alt="efunding-logo"
            :src="require(`@/assets/images/landing_page/img-logo-efunding.png`)"
            class="logo-img"
          />
          <button class="icon-button" @click="sidebarToggle">
            <XmarkIcon style="width: 2rem; height: 2rem; color: #606060" />
          </button>
        </div>

        <div class="menu-container">
          <!-- Menampilkan semua menu kecuali auth -->
          <div
            v-for="(menu, index) in navbarMenuMobile"
            :key="index"
            class="menu-wrapper"
            v-if="menu.label !== 'Login' && menu.label !== 'Daftar'"
          >
            <div
              :class="currentPath === menu.pathname ? 'menu-item-active' : 'menu-item'"
              @click="menu.children ? toggleDropdown(index) : navigateTo(menu.pathname)"
            >
              {{ menu.label }}
              <span v-if="menu.children" class="dropdown-icon">
                {{ openDropdownIndex === index ? '▲' : '▼' }}
              </span>
            </div>

            <div
              v-if="menu.children && openDropdownIndex === index"
              class="dropdown-container"
            >
              <a
                v-for="(child, childIndex) in menu.children"
                :key="childIndex"
                :href="child.pathname"
                class="dropdown-item"
              >
                {{ child.label }}
              </a>
            </div>
          </div>

          <hr class="menu-divider" />

          <!-- Jika belum login -->
          <template v-if="!userLoggedin">
            <button class="menu-button login-button" @click="navigateTo('/login')">Masuk</button>
            <button class="menu-button register-button" @click="navigateTo('/register')">Daftar</button>
          </template>

          <!-- Jika sudah login -->
          <template v-else>
            <!-- Tombol Dashboard Baru (Hanya Role 5) -->
            <!-- <button
              v-if="currentUser.info.role_id == 5"
              class="menu-button button-futuristic-mobile mb-3"
              @click="redirectToNewDashboard"
            >
              Coba Dashboard Baru ✨
            </button> -->
            <div
              @click="toggleUserDropdownMobile"
              class="button-secondary w-full flex items-center px-4 py-2 rounded-md text-white"
            >
              <div class="flex items-center">
                <i class="fas fa-user-circle mr-2"></i>
                {{ name }}
              </div>
            </div>
            <div v-if="isUserDropdownOpenMobile" class="dropdown-container">
              <a
                v-if="currentUser.info.role_id == 5"
                href="/dashboard"
                class="dropdown-item"
              >
              
                Dashboard
              </a>
              <a
                v-if="currentUser.info.role_id == 3 || currentUser.info.role_id == 4"
                href="/pengajuan-saya?q=Profil"
                class="dropdown-item"
              >
                Profil
              </a>
              <a href="#" @click="handleLogout" class="dropdown-item text-red-600">
                Sign Out
              </a>
            </div>
          </template>
        </div>
      </aside>
    </transition>
  </div>
</template>

<script>
// Icons
import Bars3Icon from "@/components/icons/Bars3Icon.vue";
import XmarkIcon from "@/components/icons/XmarkIcon.vue";

// Utils
import Cookies from 'js-cookie';
import { navbarMenu } from "@/utils/navbar_menu.js";
import { navbarMenuMobile } from "@/utils/navbar_menu_mobile.js";

export default {
  name: "NewNavbar",
  data() {
    return {
      isScrolled: false,
      is_open_sidebar: false,
      navbarMenu,
      navbarMenuMobile,
      userLoggedin: false,
      currentUser: null,
      name: "",
      isUserDropdownOpen: false,
      isProdukDropdownOpen: false,
      openDropdownIndex: null,
      isUserDropdownOpenMobile: false,
    };
  },
  components: { Bars3Icon, XmarkIcon },
  watch: {
    '$route.path'(newPath) {
      if (newPath === '/list-produk-lending' || 
      newPath === '/list-lending-detail' ||
      newPath === '/detail-produk-lending' ||
      newPath === '/list-produk-deposito-detail' ||
      newPath === '/list-produk-deposito' ||
      newPath === '/list-produk-tabungan-detail' ||
      newPath === '/syarat-dan-ketentuan' ||
      newPath === '/kebijakan-privasi' ||
      newPath === '/list-produk-tabungan'
    ) {
        this.isScrolled = true;
      } else {
        this.isScrolled = window.scrollY > 10;
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    document.addEventListener("click", this.handleClickOutside);
    this.loadData();
    this.isScrolled = this.$route.path === "/list-produk-lending" || 
    this.$route.path === "/list-lending-detail" || 
    this.$route.path === "/detail-produk-lending" || 
    this.$route.path === "/list-produk-deposito-detail" || 
    this.$route.path === "/list-produk-deposito" || 
    this.$route.path === "/list-produk-tabungan-detail" || 
    this.$route.path === "/list-produk-tabungan" || 
    this.$route.path === "/syarat-dan-ketentuan" || 
    this.$route.path === "/kebijakan-privasi" || 
    window.scrollY > 10;
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    document.removeEventListener("click", this.handleClickOutside);
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);

    const user = this.$store.state.auth.user;
    if (user) {
      this.currentUser = user;
      this.userLoggedin = true;
      this.name = user.info.name;
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    redirectToNewDashboard() {
      window.location.href = "https://staging-new.efunding.id";
    },
    toggleUserDropdownMobile() {
      this.isUserDropdownOpenMobile = !this.isUserDropdownOpenMobile
    },
    toggleDropdown(index) {
      this.openDropdownIndex = this.openDropdownIndex === index ? null : index;
    },
    navigateTo(path) {
      window.location.href = path; // atau gunakan this.$router.push(path) jika pakai Vue Router
    },
    loadData(){
      if (!['/list-lending-detail', '/detail-produk-lending'].includes(this.$route.fullPath)) {
        Cookies.remove('sub_brand_id');
      }
      if(this.$route.fullPath !== '/detail-produk-lending'){
        Cookies.remove('product_id');
      }
    },
    sidebarToggle() {
      this.is_open_sidebar = !this.is_open_sidebar;
    },
    handleScroll() {
      if (this.$route.path === "/list-produk-lending" || 
      this.$route.path === "/list-lending-detail" ||
      this.$route.path === "/detail-produk-lending" ||
      this.$route.path === "/list-produk-deposito-detail" ||
      this.$route.path === "/list-produk-deposito" ||
      this.$route.path === "/list-produk-tabungan-detail" ||
      this.$route.path === "/list-produk-tabungan" ||
      this.$route.path === "/syarat-dan-ketentuan" ||
      this.$route.path === "/kebijakan-privasi"
    ) {
        this.isScrolled = true;
      } else {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        this.isScrolled = scrollTop > 10;
      }
    },
    toggleUserDropdown() {
      this.isUserDropdownOpen = !this.isUserDropdownOpen;
    },
    registerFormOpen() {
      this.$router.push("/register");
    },
    handleLogout() {
      // Callback, bukan pemanggilan langsung: sebelumnya redirect terjadi lebih dulu
      // sehingga pembersihan sesi bisa keburu terpotong.
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push('/login');
      })
    },
    handleClickOutside(event) {
      // Dropdown User
      const userDropdown = this.$el.querySelector(".dropdown-user");
      const userButton = this.$el.querySelector(".user-dropdown-container .button-secondary");

      if (
        this.isUserDropdownOpen &&
        userDropdown &&
        !userDropdown.contains(event.target) &&
        !userButton.contains(event.target)
      ) {
        this.isUserDropdownOpen = false;
      }

      // Dropdown Produk
      const produkDropdown = this.$el.querySelector(".dropdown-produk");
      const produkButton = this.$el.querySelector(".produk-button");

      if (
        this.isProdukDropdownOpen &&
        produkDropdown &&
        !produkDropdown.contains(event.target) &&
        !produkButton.contains(event.target)
      ) {
        this.isProdukDropdownOpen = false;
      }
    },
    toggleProdukDropdown() {
      this.isProdukDropdownOpen = !this.isProdukDropdownOpen;
    },
  },
  computed: {
    currentPath() {
      return this.$route.path;
    },
    isProdukActive() {
      return this.$route.path === '/list-produk-lending' ||
            this.$route.path === '/list-lending-detail'||
            this.$route.path === '/detail-produk-lending'||
            this.$route.path === '/list-produk-deposito-detail'||
            this.$route.path === '/list-produk-deposito' ||
            this.$route.path === '/list-produk-tabungan-detail'||
            this.$route.path === '/list-produk-tabungan'||
            this.$route.path === '/layanan-kami';
    }
  },
};
</script>

<style scoped>
.menu-button {
  width: 100%;
  padding: 0.75rem 1rem;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  font-size: 1rem;
  margin-top: 0.5rem;
}

.login-button {
  background-color: #13346c; /* Biru */
  color: white;
}

.register-button {
  background-color: #f7bd3a; /* Kuning */
  color: white;
}

.menu-divider {
  border: none;
  height: 1px;
  background-color: #e0e0e0;
  margin: 1.5rem 0;
}
.menu-wrapper {
  display: flex;
  flex-direction: column;
}

.menu-item,
.menu-item-active {
  cursor: pointer;
  padding: 0.75rem 1rem;
}

.dropdown-icon {
  float: right;
  font-size: 0.75rem;
  margin-left: 8px;
}

.dropdown-container {
  padding-left: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 0.5rem;
}

.dropdown-item {
  font-size: 0.875rem;
  color: #606060;
  text-decoration: none;
}
.navbar {
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.navbar-primary {
  background-color: #13346c;
  border-bottom: 2px solid #f7bd3a;
}
.user-dropdown-container {
  position: relative;
}

.dropdown-user {
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: #274d8ed6 !important; /* Warna Biru, pakai !important */
  border-radius: 8px !important;          /* Border-radius */
  padding: 5px;
}

.dropdown-user a {
  display: block;
  padding: 10px 15px;
  text-align: left;
  color: white;               /* Warna tombol putih */
  font-size: 14px;
  border-radius: 4px;         /* Sedikit border-radius pada tombol */
  transition: background-color 0.3s ease;
}

.dropdown-produk a:hover {
  background-color: #f7bd3a;
  color: #13346c;
}

.dropdown-produk {
  background-color: #274c8e;
  border-radius: 8px;
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.dropdown-produk a {
  display: block;
  padding: 10px 15px;
  color: white;
  font-size: 14px;
  border-radius: 4px;
  text-decoration: none;
  transition: background-color 0.3s ease;
}

.dropdown-produk a:hover {
  color: #f7bd3a !important;
}

.navbar-menu-item {
  color: white;
  font-size: 18px;
  transition: all 1s;
  font-weight: 600;
  cursor: pointer;
}

.navbar-menu-item:hover {
  color: #eda600;
  border-bottom: 4px solid #eda600;
  background-color: transparent !important;
}

/* Button Style */
.button-primary {
  padding: 15px 25px;
  background-color: #f7bd3a;
  color: white;
  font-weight: 600;
  transition: all 0.5s;
  border: none;
  border-radius: 50px;
}
.button-primary:hover {
  transform: scale(105%);
}

.button-secondary {
  padding: 15px 25px;
  background-color: #274c8e;
  color: white;
  font-weight: 600;
  transition: all 0.5s;
  border: none;
  border-radius: 50px;
}
.button-secondary:hover {
  transform: scale(105%);
}

.button-futuristic {
  padding: 10px 24px;
  background: linear-gradient(45deg, #f7bd3a 0%, #eda600 100%);
  background-size: 200% 200%;
  color: #13346c;
  font-weight: 800;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 0 0 15px rgba(247, 189, 58, 0.5);
  position: relative;
  z-index: 1;
  font-size: 14px;
  animation: glowing-border-efunding 2s infinite alternate;
}

.button-futuristic:hover {
  transform: scale(1.1) rotate(-1deg);
  box-shadow: 0 0 25px rgba(247, 189, 58, 0.8), 0 0 50px rgba(19, 52, 108, 0.4);
  color: #13346c;
}

.button-futuristic-mobile {
  background: linear-gradient(45deg, #f7bd3a 0%, #eda600 100%);
  color: #13346c;
  font-weight: 800;
  box-shadow: 0 4px 15px rgba(247, 189, 58, 0.3);
}

@keyframes glowing-border-efunding {
  0% {
    background-position: 0% 50%;
    box-shadow: 0 0 10px rgba(247, 189, 58, 0.4);
  }
  100% {
    background-position: 100% 50%;
    box-shadow: 0 0 20px rgba(19, 52, 108, 0.7);
  }
}

.bg-transparent {
  background-color: transparent !important;
}
.bg-white {
  background-color: white !important;
}
.shadow-sm {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.container {
  max-width: 90%;
}

/* Sidebar */
aside {
  position: fixed;
  top: 0;
  background-color: white;
  z-index: 10;
  height: 100dvh;
  width: 100%;
  padding: 1rem;
}
.aside-header {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}
.menu-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: 2rem;
}
.menu-item {
  font-size: 18px;
  color: #000000;
}
.menu-item-active {
  font-size: 18px;
  color: #f7bd3a;
  font-weight: 600;
  border-bottom: 2px solid #f7bd3a;
  max-width: fit-content;
}
.icon-button {
  all: unset;
}

/* Transition CSS */
.sidebar-enter-active,
.sidebar-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.sidebar-enter,
.sidebar-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
.sidebar-enter-to,
.sidebar-leave-from {
  transform: translateX(0);
  opacity: 1;
}

.card-title {
  color: #fff;
  font-size: 20px;
  border-bottom: 1px solid #b3b3b3;
  padding-bottom: 20px;
  text-transform: capitalize;
  letter-spacing: 0;
  font-weight: 600;
}
.card-description {
  padding-top: 20px;
  color: #b3b3b3;
  font-size: 18px;
  text-align: justify;
}
.faq-button {
  background-color: #13346c;
  border: none;
  border-radius: 100px;
  color: white;
  padding: 18px 20px;
  font-weight: 600;
  margin: auto;
  transition: all 0.3s;
}
.faq-button:hover {
  scale: 105%;
}
.faq-button:active {
  scale: 95%;
}
.fade-opacity {
  /* Mask pakai gradient */
  -webkit-mask-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 1),
    rgba(0, 0, 0, 0)
  );
  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));

  /* Biar smooth */
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;

  /* Pastikan konten kelihatan */
  color: white;
}

@media (max-width: 767px) {
  .logo-img {
    height: 28px;
    width: auto;
  }
}

@media (min-width: 768px) {
  .logo-img {
    height: 36px;
    width: auto;
  }
}

@media (min-width: 1025px) {
  .logo-img {
    height: 48px;
    width: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newNavbarPublic.vue